export enum ChatMessageFeedback {
  Unknown = 0,
  Negative = 1,
  Positive = 2,
}
